import Button from 'presentation/shared/components/Button'
import React from 'react'
import { ContainerButtons } from './styles'

type Props = {
  confirmText: string
  confirmClick?: () => void
  confirmDisabled?: boolean
  cancelText: string
  cancelClick: () => void
  cancelDisabled?: boolean
}

export default function CancelOrConfirmButton({
  confirmText,
  confirmClick,
  confirmDisabled = false,
  cancelText,
  cancelClick,
  cancelDisabled = false
}: Props) {
  return (
    <ContainerButtons>
      <Button
        type="button"
        variant="outlined"
        onClick={cancelClick}
        disabled={cancelDisabled}
      >
        {cancelText}
      </Button>
      <Button type="button" onClick={confirmClick} disabled={confirmDisabled}>
        {confirmText}
      </Button>
    </ContainerButtons>
  )
}
